/*
 * "sim/..."-Schauwerte wie am Panel (simPoints.ts): was die Anlage nicht
 * misst, etwa Leistung und PV, zeigen Web-HMI und HMI-Reiter der Anlage
 * genauso wie die lokale. Alles andere bleibt die echte Quelle, auch die
 * Bedienung.
 */

import { useMemo } from 'preact/hooks';
import type { ComponentChildren } from 'preact';
import { PointBindingSourceProvider, useOptionalPointBindingSource } from './PointBindingProvider';
import { withSimulatedPoints } from './simPoints';

export function WithSimulation({ children }: { children: ComponentChildren }) {
  const real = useOptionalPointBindingSource();
  const source = useMemo(() => (real ? withSimulatedPoints(real) : null), [real]);
  return source ? <PointBindingSourceProvider source={source}>{children}</PointBindingSourceProvider> : <>{children}</>;
}
